import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { isEmpty } from 'lodash';
import { escapeRegExp } from '../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TitlesService {
  private title = inject(Title);
  private cachedTitles: { [key: string]: string } = {};

  changeTitleParam(data: { paramName: string; value: string }[]) {
    let title = this.title.getTitle();

    data.forEach(({ paramName, value }) => {
      const prevValue = this.cachedTitles[paramName];
      if (prevValue) {
        const prevPattern = new RegExp(escapeRegExp(prevValue), 'g');
        title = title.replace(prevPattern, paramName);
      }

      this.cachedTitles[paramName] = value;

      if (paramName) {
        const namePattern = new RegExp(escapeRegExp(paramName), 'g');
        title = title.replace(namePattern, value);
      }
    });

    this.title.setTitle(title);
  }

  changeTitleFromCache(title: string) {
    if (!isEmpty(this.cachedTitles)) {
      Object.entries(this.cachedTitles).forEach(([paramName, value]) => {
        title = title?.replace(paramName, value);
      });

      return title;
    }

    return title;
  }

  clearCachedTitles() {
    this.cachedTitles = {};
  }
}
